import React, { useContext } from "react";

import { IconMobile, List } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";

import { MenuItem } from "../../../MenuItem";
import { MobileMenuContext } from "../../../MobileMenuContext";

const GiftCardsItem = styled(MenuItem)`
  margin: 0px;
  padding: 0px 15px;
  border-top: 4px solid ${themeGet("colors.ui.borderColor")};
  border-bottom: 4px solid ${themeGet("colors.ui.borderColor")};
`;

const EssentialsItem = styled(MenuItem)`
  padding-left: 7px;
  align-items: center;
  flex-direction: row;

  svg {
    margin-right: 8px;
    width: 16px;
  }

  svg,
  a:focus svg,
  a:active svg {
    color: #979797;
  }
`;

type CatchEssentialsMenuProps = {
  startIndex: number;
};

export const CatchEssentialsMenu = ({
  startIndex,
}: CatchEssentialsMenuProps) => {
  const { essentialsMenu } = useContext(MobileMenuContext);
  const { giftCards, catchMobile } = essentialsMenu || {};

  return (
    <List mb="0px" aria-label="Catch essentials menu">
      {giftCards && (
        <GiftCardsItem
          url={giftCards}
          itemPath={[
            {
              name: "Gift Cards",
              id: 0,
              position: startIndex + 1,
            },
          ]}
        >
          Gift Cards
        </GiftCardsItem>
      )}
      {catchMobile && (
        <EssentialsItem
          url={catchMobile}
          itemPath={[
            {
              name: "Catch Mobile",
              id: 0,
              position: startIndex + 2,
            },
          ]}
        >
          <IconMobile height="20px" />
          Catch Mobile
        </EssentialsItem>
      )}
    </List>
  );
};
